import { render, staticRenderFns } from "./ContabilitaDocumentiCollegatiComponent.vue?vue&type=template&id=e6dc5a92&scoped=true"
import script from "./ContabilitaDocumentiCollegatiComponent.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentiCollegatiComponent.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaDocumentiCollegatiComponent.vue?vue&type=style&index=0&id=e6dc5a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6dc5a92",
  null
  
)

export default component.exports